// extracted by mini-css-extract-plugin
export var conversationListItem = "_wp-2";
export var fullBleedList = "_wp-3";
export var messageText = "_wp-1";
export var previewText = "_wp-0";